import { FC } from 'react'
import { BackInTime } from '@emotion-icons/entypo/BackInTime'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { AcquisitionHistoryContent } from 'src/v2/views/owner-reveal/insights/acquisition-history/content'
import { AcquisitionsOverview } from 'src/v2/views/owner-reveal/insights/acquisition-history/acquisitions-overview'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { Insight, InsightComponentProps } from 'src/components/insights/types'

const AcquisitionContent: FC<InsightComponentProps> = ({ insight }) => {
  return (
    <InsightContainer insight={insight}>
      <AcquisitionHistoryContent />
      <AcquisitionsOverview />
    </InsightContainer>
  )
}

export const AcquisitionHistory: Insight = {
  id: 'acquisition-history',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['entity-acquisition-history-tab'],
  component: AcquisitionContent,
  name: 'Acquisition History',
  icon: BackInTime,
  linkTooltipFile: 'acquisition-history',
  supportedResultTypes: ['owner'],
}
